import {FC} from "react";
import {Column} from "../atoms/Layout.tsx";
import LogoWithTitle from "../molecules/LogoWithTitle.tsx";

const FullPageLoader: FC = () => {
    return <Column grow centerVertically centerHorizontally gap="40">
        <LogoWithTitle />
    </Column>
}

export default FullPageLoader;